import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../../lib/utils";

export const Route = createFileRoute("/library/$moduleSlug")({
  head: () => pageHead("page.module"),
});
